import * as Stimulus from "@hotwired/stimulus"

export class ResizableTextareaController extends Stimulus.Controller {
    static classes = ["noResize"]

    connect() {
        if (this.hasNoResizeClass) {
            this.element.classList.add(...this.noResizeClasses);
        }
        this.resize();
    }

    resize() {
        this.element.style.height = "auto";
        this.element.style.height = `${this.element.scrollHeight}px`;
    }
}
